<div class="displayTable">
    <div class="displayTableCell">
      <div class="authBlock">
        <h3>Reset Password</h3>
  
        <p class="text-center">Please enter your email address to request a password reset.</p>
  
   

          <mat-form-field class="full-width">
            <input matInput type="email" class="" placeholder="Email Address" #passwordResetEmail required>
            </mat-form-field>
  
        
        <div class="formGroup center">
          <button type="submit" mat-raised-button class="btn-blue-royal" value="Reset Password" 
            (click)="authService.ForgotPassword(passwordResetEmail.value)">
            Reset Password</button>
        </div>
        <div class="redirectToLogin">
          <span style = "color: black">Go back to<span style = "color: blue" class="redirect" routerLink="/sign-in"> Log In </span></span>
        </div>
      </div>
    </div>
  </div>